import { Check } from "lucide-react";
import { addonLabelPrice } from "@/lib/estimate";

export default function PackageStep({ pricing, tier, setTier, addons, setAddons }) {
  const toggle = (k) => setAddons(addons.includes(k) ? addons.filter((a) => a !== k) : [...addons, k]);
  return (
    <div data-testid="package-step">
      <p className="text-sm text-brand-muted mb-4">Choose a finish level</p>
      <div className="grid md:grid-cols-3 gap-4">
        {Object.entries(pricing.tiers).map(([k, t]) => (
          <button key={k} onClick={() => setTier(k)} data-testid={`tier-option-${k}`}
            className={`text-left rounded-2xl p-6 border-2 transition-colors ${tier === k ? "border-brand-accent bg-brand-cream" : "border-brand-line bg-brand-sand hover:border-brand-accent/50"}`}>
            <div className="flex justify-between items-center">
              <p className="font-serif-display text-3xl text-brand-ink">{t.label}</p>
              {tier === k && <span className="w-6 h-6 rounded-full bg-brand-accent grid place-items-center"><Check className="w-3.5 h-3.5 text-white" /></span>}
            </div>
            <p className="text-sm text-brand-ink mt-2">from ₹{t.rate_from.toLocaleString("en-IN")}/sq.ft</p>
            {t.description && <p className="text-xs text-brand-muted mt-2 leading-relaxed">{t.description}</p>}
            <p className="text-xs text-brand-muted-light mt-3 leading-relaxed">{t.materials}</p>
          </button>
        ))}
      </div>
      <p className="text-sm text-brand-muted mt-10 mb-4">Enhance with add-ons</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {Object.entries(pricing.addons).map(([k, a]) => {
          const on = addons.includes(k);
          return (
            <button key={k} onClick={() => toggle(k)} data-testid={`addon-${k}`}
              className={`flex items-center justify-between rounded-xl border px-5 py-4 text-left transition-colors ${on ? "border-brand-accent bg-brand-accent/5" : "border-brand-line bg-brand-cream hover:border-brand-accent/50"}`}>
              <span><span className="block text-sm text-brand-ink">{a.label}</span><span className="text-xs text-brand-muted">{addonLabelPrice(a)}{a.description ? ` · ${a.description}` : ""}</span></span>
              <span className={`w-5 h-5 rounded border grid place-items-center shrink-0 ml-3 ${on ? "bg-brand-accent border-brand-accent" : "border-brand-line"}`}>{on && <Check className="w-3 h-3 text-white" />}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
